import React, { useEffect, useState } from "react";
import { Card, Image, Tabs } from "antd";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import Pets from "./tabs/pets";
import Feedback from "./tabs/feedback";
import Subscription from "./tabs/subscription";
import Transaction from "./tabs/transaction";
import BackButton from "../../../component/common/Back-Button";
import { useNavigate, useParams } from "react-router-dom";
import { role } from "../../../util/Route";
import { apiGenerator } from "../../../util/functions";
import useHttp from "../../../hooks/use-http";
import temp_img from '../../../asset/image/dummy-avatar.jpg'

const UserDetail = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const api = useHttp();


  const commonClass = "text-base ";

  const menus = {
    pets: <Pets />,
    feedback: <Feedback />,
    subscription: <Subscription />,
    transaction: <Transaction />,
    // mode: <ModeFeedback />,
  };
  const navigate = useNavigate();
  useEffect(() => {
    const USER_GET_DATA_API = apiGenerator(CONSTANTS.API.User.getOne, {
      id
    });
    api.sendRequest(USER_GET_DATA_API, (res) => {
      setUserData(res?.data)
    })
  }, [])

  return (
    <>
      <div >
        <Card className="my-8 w-[35%] 2xl:w-[30%]" >
          <div className="flex items-center gap-3">
            <div>
              <Image className="rounded-full object-cover" width={70} height={70} src={userData?.profilePic || temp_img} alt='user profile' />
            </div>
            <div>
              <p className="font-medium text-xl">{userData?.name}</p>
            </div>
          </div>
          {/* Mobile */}
          <p className={`${commonClass} my-3`}>
            Mobile : {userData?.mobile}
          </p>
          {/* Email */}
          <p className={`${commonClass}`}>
            Email : {userData?.email}
          </p>
        </Card>
        <Card className="">
          {role === 'Admin' && <BackButton onClick={() => navigate(-1)} />}
          <Tabs
            className="p-0 m-0"
            defaultActiveKey="1"
            size="middle"
            type="card"
            items={CONSTANTS.TAB_MENU.USER.map((ele) => {
              if (ele.Role.includes(role)) {
                return {
                  label: `${ele.Label}`,
                  key: `${ele.id}`,
                  children: menus[ele?.id],
                };
              }
            })}
          />
        </Card>
      </div>
    </>
  );
};

export default UserDetail;
